export const CLIENT_MANAGEMENT_PRIVILEGES = {
  retail: {
    access: [
      "clientManagement.retail.operations.export",
      "clientManagement.retail.operations.add",
      "clientManagement.retail.operations.view",
      "clientManagement.retail.operations.edit",
      "clientManagement.retail.operations.delete"
    ],
    export: "clientManagement.retail.operations.export",
    add: "clientManagement.retail.operations.add",
    view: "clientManagement.retail.operations.view",
    edit: "clientManagement.retail.operations.edit",
    delete: "clientManagement.retail.operations.delete"
  },
  corporate: {
    access: [
      "clientManagement.corporate.operations.export",
      "clientManagement.corporate.operations.add",
      "clientManagement.corporate.operations.view",
      "clientManagement.corporate.operations.edit",
      "clientManagement.corporate.operations.delete"
    ],
    export: "clientManagement.corporate.operations.export",
    add: "clientManagement.corporate.operations.add",
    view: "clientManagement.corporate.operations.view",
    edit: "clientManagement.corporate.operations.edit",
    delete: "clientManagement.corporate.operations.delete"
  }
};

// Add Client opens a standalone form from several workflows. It must not expose
// the System Settings client-list navigation by itself.
export const retailClientAccessPrivileges = [
  CLIENT_MANAGEMENT_PRIVILEGES.retail.export,
  CLIENT_MANAGEMENT_PRIVILEGES.retail.view,
  CLIENT_MANAGEMENT_PRIVILEGES.retail.edit,
  CLIENT_MANAGEMENT_PRIVILEGES.retail.delete
];
export const corporateClientAccessPrivileges = [
  CLIENT_MANAGEMENT_PRIVILEGES.corporate.export,
  CLIENT_MANAGEMENT_PRIVILEGES.corporate.view,
  CLIENT_MANAGEMENT_PRIVILEGES.corporate.edit,
  CLIENT_MANAGEMENT_PRIVILEGES.corporate.delete
];
export const clientManagementAccessPrivileges = [
  ...retailClientAccessPrivileges,
  ...corporateClientAccessPrivileges
];
